import { Head, useForm, Link } from '@inertiajs/react'
import Input from '../../components/ui/Input'
import Button from '../../components/ui/Button'

/**
 * SignIn page - User authentication
 * Route: GET /sign-in
 * Form submits to: POST /sign-in
 */
export default function SignIn() {
  const { data, setData, post, processing, errors } = useForm({
    email: '',
    password: ''
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    post('/sign-in')
  }

  return (
    <>
      <Head title="Connexion" />

      <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          {/* Header */}
          <div>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
              Connexion à votre compte
            </h2>
            <p className="mt-2 text-center text-sm text-gray-600">
              Gérez vos leads et votre agence
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="mt-8 space-y-6">
            <div className="space-y-4">
              <Input
                label="Email"
                type="email"
                name="email"
                value={data.email}
                onChange={(e) => setData('email', e.target.value)}
                error={errors.email}
                required
                autoFocus
                placeholder="vous@example.com"
              />

              <Input
                label="Mot de passe"
                type="password"
                name="password"
                value={data.password}
                onChange={(e) => setData('password', e.target.value)}
                error={errors.password}
                required
                placeholder="••••••••"
              />
            </div>

            {/* Forgot password link */}
            <div className="flex items-center justify-end">
              <Link
                href="/identity/password_reset/new"
                className="text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
              >
                Mot de passe oublié ?
              </Link>
            </div>

            {/* Submit button */}
            <Button
              type="submit"
              variant="primary"
              size="lg"
              className="w-full"
              disabled={processing}
              loading={processing}
            >
              Se connecter
            </Button>
          </form>

          {/* Help text */}
          <div className="text-center">
            <p className="text-sm text-gray-500">
              Besoin d'un compte ? Contactez votre administrateur.
            </p>
          </div>
        </div>
      </div>
    </>
  )
}
